import { render, staticRenderFns } from "./activity-video-enroll-list.vue?vue&type=template&id=6a8996d4&scoped=true&"
import script from "./activity-video-enroll-list.vue?vue&type=script&lang=js&"
export * from "./activity-video-enroll-list.vue?vue&type=script&lang=js&"
import style0 from "./activity-video-enroll-list.vue?vue&type=style&index=0&id=6a8996d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8996d4",
  null
  
)

export default component.exports